borderDirectiveModule = angular.module('border.setting', [])

borderDirectiveModule.directive "borderSetting", ["$window", "$timeout", "$compile", "$templateCache", "translitService", "editorDragPanel", ($window, $timeout, $compile, $templateCache, translitService, editorDragPanel) ->
  restrict: "A",
  scope: {data: "=ngModel", afterChange: '&'},
  templateUrl: "#{settingFolder}/border/template.jade"
  link: (scope, element, attrs, ngModel) ->


    scope.borderStyle = [
      {style: "solid", name: "Solid", title: "modulesSettings.borderStyle1"}
      {style: "dotted", name: "Dotted", title: "modulesSettings.borderStyle2"}
      {style: "dashed", name: "Dashed", title: "modulesSettings.borderStyle3"}
      {style: "double", name: "Double", title: "modulesSettings.borderStyle4"}
      {style: "groove", name: "Groove", title: "modulesSettings.borderStyle5"}
      {style: "ridge", name: "Ridge", title: "modulesSettings.borderStyle6"}
      {style: "inset", name: "Inset", title: "modulesSettings.borderStyle7"}
      {style: "outset", name: "Outset", title: "modulesSettings.borderStyle8"}
    ]

    if !scope.data
      scope.data = "0px solid rgba(255, 255, 255, 1)"

    borderSplit = scope.data.split(" ", 2)

    scope.border = {
      width: parseInt(borderSplit[0])
      style: borderSplit[1]
      color: scope.data.split(" ").slice(2).join(" ")
    }

    listener = scope.$watch "border", (newVal, oldVal) ->
      scope.data = "#{newVal.width} #{newVal.style} #{newVal.color}"
      if scope.afterChange
        scope.afterChange();
    , true

    scope.$on "$destroy", ->
      listener()

]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/border/border.directive.coffee